import Component from './component.vue';

export default Component;



// WEBPACK FOOTER //
// ./src/pages/noko/info/index.ts